import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import MyImage from '@shared/components/myImage'
import close from '@assets/images/icon/close-circle.svg'
import styles from './style.module.scss'
import ShortsSlider from '../shortsSlider'

function ShortsDetail({ isOpen, onClose, data, vidNumber }) {
  const sliderRef = useRef(null)
  const playersRef = useRef({})
  const currentPlayingRef = useRef(null)

  useEffect(() => {
    if (isOpen && sliderRef.current) {
      const element = sliderRef.current.querySelectorAll(`.${styles.carouselItem}`)[vidNumber]
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }, [isOpen, vidNumber])

  if (!isOpen) return null

  const handleModalClick = (event) => {
    event.stopPropagation()
  }

  useEffect(() => {
    if (!isOpen) return
    if (window.YT) return

    const tag = document.createElement('script')
    tag.src = 'https://www.youtube.com/iframe_api'
    document.body.appendChild(tag)

    window.onYouTubeIframeAPIReady = () => {
      if (!window.YT) return

      const iframes = sliderRef.current.querySelectorAll('iframe')
      iframes.forEach((iframe, index) => {
        const player = new window.YT.Player(iframe.id, {
          events: {
            onStateChange: (event) => {
              if (event.data === window.YT.PlayerState.PLAYING) {
                if (currentPlayingRef.current && currentPlayingRef.current !== player) {
                  currentPlayingRef.current.pauseVideo()
                }

                currentPlayingRef.current = player
              }
            }
          }
        })

        playersRef.current[iframe.id] = player
      })
    }
  }, [isOpen])

  return (
    <div className={styles.modal}>
      <div className={styles.modalHeader}>
        <button className={styles.modalClose} onClick={onClose}>
          <MyImage src={close} alt='close' />
        </button>
      </div>
      <div className={styles.modalContent} onClick={handleModalClick}>
        <div ref={sliderRef}>
          <ShortsSlider nav gap={22} destroyBelow={1199} vertical>
            {data?.map((item, index) => (
              <div key={item._id} className={styles.carouselItem}>
                <div className={styles.titleText}>
                  <p>{item.sTitle}</p>
                </div>
                <div className={styles.iframeContainer}>
                  <iframe
                    id={`youtube-player-${index}`}
                    className={`${styles.videoMain} d-block`}
                    src={`https://${item?.oPlayer?.sEmbedUrl}?enablejsapi=1`}
                    title={item?.sTitle}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  />
                </div>
              </div>
            ))}
          </ShortsSlider>
        </div>
      </div>
    </div>
  )
}

ShortsDetail.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.array,
  vidNumber: PropTypes.number
}

export default ShortsDetail
